import { ContractAbstraction, ContractProvider, Context, Wallet } from '@taquito/taquito';
import { DEFAULT_HANDLERS, Handler, IpfsHttpHandler, MetadataProvider, Tzip16Uri } from '@taquito/tzip16';

// Taquito's default gateway (ipfs.io) no longer serves the TZIP-16 metadata reliably,
// so name resolution through off-chain views needs gateways that work, tried in order.
export const IPFS_GATEWAYS = ['ipfs.filebase.io', 'gateway.pinata.cloud', '4everland.io'];

export class FallbackIpfsHandler implements Handler {
    constructor(private handlers: Handler[]) {}

    async getMetadata(contract: ContractAbstraction<ContractProvider | Wallet>, uri: Tzip16Uri, context: Context): Promise<string> {
        let lastError: unknown = new Error('No IPFS gateway configured.');

        for (const handler of this.handlers) {
            try {
                return await handler.getMetadata(contract, uri, context);
            } catch (error) {
                lastError = error;
            }
        }

        throw lastError;
    }
}

export function createMetadataProvider(gateways = IPFS_GATEWAYS): MetadataProvider {
    const handlers = new Map(DEFAULT_HANDLERS);
    handlers.set('ipfs', new FallbackIpfsHandler(gateways.map(gateway => new IpfsHttpHandler(gateway))));

    return new MetadataProvider(handlers);
}
